import React, { useCallback, useEffect } from "react";

import EnumWalletTypes from "@wallet-manager/node-types/dist/types/postgres/const/WalletType";

import AddressBookSuggestion from "../../../../../components/AddressBookSuggestion";
import { useTranslation } from "../../../../../hooks";
import { AddressBookOrder } from "../../../../AssetManagement/Swap/types";
import LayoutRow from "../../components/LayoutRow";
import ChainNameSingleSelection from "../../components/rent/ChainNameSingleSelection";
import DurationSingleSelection from "../../components/rent/DurationSingleSelection";
import { RentDialogFields } from "../../types";
import RentPricingTable from "./RentPricingTable";

interface IProps {
  fields: RentDialogFields;
  setFields: React.Dispatch<React.SetStateAction<RentDialogFields>>;
}

const DEFAULT_CHAIN_NAME = "TRX";

const RentRequestTabRentDialogContent = (props: IProps) => {
  const { fields, setFields } = props;

  const { t } = useTranslation("tronWalletResourceBalance");

  const clearSelect = (fieldKey: string) => {
    setFields({
      ...fields,
      [fieldKey]: "",
    });
  };

  const updateField = (fieldKey: string, value: any) => {
    setFields({
      ...fields,
      [fieldKey]: value,
    });
  };

  const updateWalletAddress = useCallback(
    (name: keyof AddressBookOrder, value: string) => {
      if (name === "to_address" || name === "rawItem") {
        return setFields((prevFields: any) => ({
          ...prevFields,
          ...(name === "to_address" && {
            receivingAddress: value,
            addressBookOrder: {
              ...prevFields.addressBookOrder,
              [name]: value,
            },
            ...(value === "" ? { balance: "", rawWalletInfo: null } : {}),
          }),
          ...(name === "rawItem" && {
            rawWalletInfo: value,
          }),
        }));
      }
    },
    [setFields]
  );

  useEffect(() => {
    if (!fields.chainName) {
      setFields({
        ...fields,
        chainName: DEFAULT_CHAIN_NAME,
      });
    }
  }, []);

  return (
    <div>
      <LayoutRow
        title={t("chainName")}
        content={<ChainNameSingleSelection value={"TRX"} onChange={() => {}} />}
      />

      <LayoutRow
        title={t("receivingAddress")}
        content={
          <AddressBookSuggestion
            item={fields.addressBookOrder as AddressBookOrder}
            isAllowFreeInput={false}
            isDisabled={false}
            walletTypes={[String(EnumWalletTypes.HotWallet)]}
            chain_name={"TRX"}
            setField={updateWalletAddress}
            config={{
              placeHolder: t("plzEnterAddress"),
            }}
          />
        }
      />

      <LayoutRow
        title={t("duration")}
        content={
          <DurationSingleSelection
            value={fields.duration || ""}
            onChange={(event) => updateField("duration", event.target.value)}
            onClear={() => clearSelect("duration")}
          />
        }
      />

      <div
        style={{
          height: "1px",
          backgroundColor: "rgba(0,0,0,0.2)",
          margin: "20px 0 12px",
        }}
      ></div>

      {/* new section */}
      <div>
        <RentPricingTable setFields={setFields} />
      </div>

      {/* <LayoutRow
        title={t("energyAmount")}
        subtitle={
          <Button
            onClick={() => {
              setIsGuidanceDialogOpen(true);
            }}
            sx={{ textTransform: "none", padding: 0 }}
          >
            {t("rentResourceGuidance")}
          </Button>
        }
        content={
          <NumberOfTransactionEnergyTextField
            label={t("phEnergyAmount")}
            value={fields.numberOfTransactionEnergy || ""}
            onChange={(event) =>
              updateField("numberOfTransactionEnergy", event.target.value)
            }
          />
        }
      /> */}
      {/* <LayoutRow
        title={t("bandwidthAmount")}
        subtitle={
          <Button
            onClick={() => {
              setIsGuidanceDialogOpen(true);
            }}
            sx={{ textTransform: "none", padding: 0 }}
          >
            {t("rentResourceGuidance")}
          </Button>
        }
        content={
          <NumberOfTransactionBandwidthTextField
            label={t("phBandwidthAmount")}
            value={fields.numberOfTransactionBandwidth || ""}
            onChange={(event) =>
              updateField("numberOfTransactionBandwidth", event.target.value)
            }
          />
        }
      /> */}

      {/* <LayoutRow
        title={t("orderId")}
        content={
          <OrderIdTextField
            value={fields.orderId || ""}
            onChange={(event) => updateField("orderId", event.target.value)}
          />
        }
      /> */}
    </div>
  );
};

export default RentRequestTabRentDialogContent;
